import { Injectable } from '@angular/core';
import { ArrayUtil } from 'src/app/utils/array.util';
import { CheckerUtil } from 'src/app/utils/checker.util';
import { ColorUtil } from 'src/app/utils/color.util';
import { DateUtil } from 'src/app/utils/date.util';
import { HashingUtil } from 'src/app/utils/hashing.util';
import { NumberUtil } from 'src/app/utils/number.util';
import { TimeUtil } from 'src/app/utils/time.util';

@Injectable({
  providedIn: 'root'
})
export class UtilsManager {

  constructor(
    private _checker    : CheckerUtil ,
    private _hash       : HashingUtil ,
    private _color      : ColorUtil   ,
    private _time       : TimeUtil    ,
    private _date       : DateUtil    ,
    private _array      : ArrayUtil   ,
    private _number     : NumberUtil
  ) { }

  checker()
  {
    return this._checker
  } 

  hash()
  {
    return this._hash
  }

  color()
  {
    return this._color
  }

  time()
  {
    return this._time
  }
  
  date()
  {
    return this._date
  }

  array()
  {
    return this._array
  }

  number(){
    return this._number
  }
}
